import React, { useState } from 'react';
import { NavigationContextInterface } from './models.d';

export const NavigationContext =
  React.createContext<NavigationContextInterface>({
    isSideBar: false,
    showSideBar: () => ({}),
    closeSideBar: () => ({}),
  });

export const NavigationContextProvider = ({ children }) => {
  const [isSideBar, setSideBar] = useState(false);

  const showSideBar = () => {
    setSideBar(true);
  };

  const closeSideBar = () => {
    setSideBar(false);
  };

  return (
    <NavigationContext.Provider
      value={{
        isSideBar,
        showSideBar,
        closeSideBar,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
